import { axiosClient } from './request';

const transactionServices = {
  list({
    pageSize = 20,
    pageIndex = 0,
    sort_by = '',
    globalFilter = '',
    dates = [null, null],
    moreFilterData = {}
  } = {}) {
    return axiosClient.get('/transactions', {
      params: {
        limit: pageSize,
        page: pageIndex + 1,
        search: globalFilter,
        sort_by,
        start_time: dates[0],
        end_time: dates[1],
        ...moreFilterData
      }
    });
  },
  detail(id) {
    return axiosClient.get(`/transactions/${id}`);
  },
  detailSubsidy(id) {
    return axiosClient.get(`/transactions/subsidies/${id}`);
  },
  listSubsidies({
    pageSize = 20,
    pageIndex = 0,
    sort_by = '',
    dates = [null, null],
    moreFilterData = {}
  } = {}) {
    return axiosClient.get('/transactions/subsidies', {
      params: {
        limit: pageSize,
        page: pageIndex + 1,
        sort_by,
        start_time: dates[0],
        end_time: dates[1],
        ...moreFilterData
      }
    });
  },
  listSubsidiesPortal({
    pageSize = 20,
    pageIndex = 0,
    sort_by = '',
    dates = [null, null],
    moreFilterData = {}
  } = {}) {
    return axiosClient.get('/transactions/subsidies/portal', {
      params: {
        limit: pageSize,
        page: pageIndex + 1,
        sort_by,
        start_time: dates[0],
        end_time: dates[1],
        ...moreFilterData
      }
    });
  },
  exportTransaction(data) {
    return axiosClient.post(`/transactions/export`, data);
  },
  exportSubsidies(data) {
    return axiosClient.post(`/transactions/subsidies/export`, data);
  },
  listByFleet({
    pageSize = 20,
    pageIndex = 0,
    sortBy = [],
    globalFilter = '',
    dates = [null, null]
  } = {}) {
    const _sortBy = sortBy.map(item => `${item.id}.${item.desc ? 'desc' : 'asc'}`).toString();
    return axiosClient.get('/fleets', {
      params: {
        limit: pageSize,
        page: pageIndex + 1,
        search: globalFilter,
        sort_by: _sortBy,
        start_date: dates[0],
        end_date: dates[1]
      }
    });
  },
  detailByFleet(id) {
    return axiosClient.get(`/fleets/${id}`);
  },
  getStatistic(params) {
    return axiosClient.get('transactions/statistics', { params });
  },
  onTransactionRefund(id, body, countryCode) {
    return axiosClient.post(`/transactions/${id}/refund`, body, {
      headers: {
        'x-region': countryCode || ''
      }
    });
  },
  sendingReceipt(id, body) {
    return axiosClient.post(`/transactions/${id}/receipts/sending`, body);
  }
};

export default transactionServices;
